import { ActionMap } from "@context/types/index";

export enum TypesDescribe {
  Finish = "FINISH",
}

export interface IDescribeCase {
  detail: string;
  evidence?: File;
}
export type DescribeCasePayload = {
  [TypesDescribe.Finish]: IDescribeCase;
};

export type DescribeCaseActions = ActionMap<
  DescribeCasePayload
>[keyof ActionMap<DescribeCasePayload>];
